<h3 mat-dialog-title>Last Input</h3>

<p>The application is offline.</p>
<p>This collection will be permanently saved the next time a network connection is established.</p>

<mat-dialog-actions>
  <button mat-raised-button matDialogClose>Close</button>
</mat-dialog-actions>
